import editBudgetStore from "../../../../helpers/Budget/editBudgetStore";
import budgetKeys from "../budgetKeys";

const editLineitemResponder = (queryClient) => {
  return {
    onSuccess: (returnedData) => {
      const budgertId = returnedData.budget.split("/")[1];
      const queryKey = budgetKeys.byId(budgertId);
      const oldData = queryClient.getQueryData(queryKey);
      const lineItems = oldData.lineItems.map((li) => {
        if (li.id === returnedData.id) {
          return returnedData;
        }
        return li;
      });

      const budgetId = oldData?.budget?.id;

      editBudgetStore({
        queryClient,
        id: budgetId,
        updatedFields: { lineItems },
      });
    },
    onError: (err) => console.error("Error", err),
  };
};

export default editLineitemResponder;
